<template>
	<div class="loading-container" :style="pointerEvents">
		<slot/>
		<div v-if="show" :style="loadingStylesWrapperContainer" class="loading loading-container-wrapper">
			<div v-if="true" :style="loadingStylesBackground" class="loading loading-container-background"/>
			<div  v-if="true" class="loading loading-container-foreground">
				<v-container class="center-no-padding-nor-margin">
					<v-row class="center-no-padding-nor-margin">
						<v-col cols="12" class="center-no-padding-nor-margin">
							<v-progress-circular indeterminate
								:color="spinnerColor"
								:size="spinnerSize"
								:width="spinnerSize * (1/8)" class="ma-0 pa-0"/>
							<h4 v-if="text" class="white--text pl-3">
								{{ text }}
							</h4>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>
	</div>
</template>

<script setup>
import { manterApenasNumeros } from "@/utils/StringUtils.js";
import { computed } from "vue";

const props = defineProps({
	show: {
		required: true,
		default: false,
	},
	text: {
		type: String,
		default: "",
	},
	spinnerSize: {
		type: Number,
		default: 40,
	},
	spinnerColor: {
		type: String,
		default: "white",
	},
	backgroundColor: {
		type: String,
		default: "black",
	},
	backgroundOpacity: {
		type: [String, Number],
		default: 0.4,
	},
	backgroundBlur: {
		type: [String, Number],
		default: "0",
	},
});

const loadingStylesWrapperContainer = computed(() => {
	return {
		"backdrop-filter": `blur(${manterApenasNumeros(props.backgroundBlur)}px)`,
		overflow: "hidden",
	}
});

const loadingStylesBackground = computed(() => {
	return {
		"background-color": props.backgroundColor,
		opacity: props.backgroundOpacity,
	}
});

const pointerEvents = computed(() => {
	if (props.show) {
		return "pointer-events: none";
	}
	return "";
});
</script>

<style scoped>
.loading{
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0px;
	left: 0px;
}

.loading-container-wrapper{
	z-index: 2;
}

.loading-container-background{
	z-index: 3;
}

.loading-container-foreground{
	z-index: 4;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}

.loading-container{
	position: relative;
	overflow: hidden;
}

.center-no-padding-nor-margin{
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
	padding: 0;
}
</style>
